// src/pages/Home.jsx
import React from "react";
/* ===================== HERO (pure code, no images) ===================== */
function Hero({ onOpenGallery }) {
  return (
    <section className="relative overflow-hidden">
      {/* înălțimi + spațiu sub navbar (transparent) */}
      <div className="relative h-[420px] sm:h-[460px] md:h-[520px] lg:h-[560px] pt-16 sm:pt-20">

        {/* Gradient principal din culorile brand */}
        <div className="absolute inset-0 bg-gradient-to-br from-[#2a2306] via-[#348286] to-[#ff5154]" />

        {/* Blobs blurate pentru profunzime */}
        <div className="absolute -top-16 -left-16 h-72 w-72 rounded-full bg-white/10 blur-3xl" />
        <div className="absolute -bottom-10 -right-10 h-80 w-80 rounded-full bg-black/20 blur-3xl" />

        {/* Pattern discret (grid de puncte) */}
        <svg className="absolute inset-0 h-full w-full opacity-20" aria-hidden="true">
          <defs>
            <pattern id="dotgrid" width="24" height="24" patternUnits="userSpaceOnUse">
              <circle cx="1" cy="1" r="1" fill="white" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#dotgrid)" />
        </svg>

        {/* Siluetă mașină – ascunsă pe mobil, vizibilă de la sm+ și coborâtă mai jos */}
        <svg
          className="pointer-events-none absolute bottom-[-6%] right-0 hidden sm:block h-[52%] md:h-[58%] opacity-30 md:opacity-40"
          viewBox="0 0 900 400"
          fill="none"
          stroke="white"
          strokeWidth="6"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M120 270c30-40 80-70 140-85 35-8 70-12 110-35 40-22 75-55 115-60 60-8 120 30 150 68 18 22 40 35 75 47 35 12 65 42 65 65 0 20-15 30-38 30H146" opacity=".7"/>
          <circle cx="230" cy="300" r="46" />
          <circle cx="230" cy="300" r="18" />
          <circle cx="680" cy="300" r="46" />
          <circle cx="680" cy="300" r="18" />
          <path d="M330 180h170c25 0 40 15 52 36l14 24" opacity=".7"/>
          <path d="M120 270h-40" />
          <path d="M780 270h70" />
        </svg>

        {/* Card de conținut */}
        <div className="absolute inset-0 grid place-items-center px-4">
          <div className="max-w-2xl w-full rounded-brand bg-white/15 backdrop-blur-md shadow-glass p-6 sm:p-8 text-center space-y-3 border border-white/30">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight text-white drop-shadow">
              Manu <span className="text-manupro-primary">Pro</span> Detailing
            </h1>
            <p className="text-base sm:text-lg text-white/90 leading-relaxed">
              Detailing interior & exterior, protecții ceramice și recondiționare faruri – atenție la fiecare detaliu.
            </p>
            <div className="flex items-center justify-center gap-3 pt-1">
              <a
                href="tel:+40762705175"
                className="rounded-full px-5 py-3 font-medium text-white bg-manupro-primary shadow-brand ring-1 ring-manupro-ring/60 transition-colors hover:brightness-110"
              >
                Sună acum
              </a>
              <button
                onClick={onOpenGallery}
                className="rounded-full px-5 py-3 font-medium bg-white text-manupro-ink border border-white/80 hover:bg-white/90"
              >
                Vezi galeria
              </button>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}


/* ===================== SERVICII (carduri individuale cu icoane) ===================== */
function Services() {
  const interior = [
    { icon: <IconSteam />, text: "Curățare material textil cu injecție/extracție + aburi" },
    { icon: <IconCarpet />, text: "Curățare mochetă cu injecție/extracție" },
    { icon: <IconDashboard />, text: "Curățare completă a elementelor din plastic" },
    { icon: <IconShield />, text: "Tratament antistatic & anti-îmbătrânire (plastic & cauciuc)" },
    { icon: <IconTrunk />, text: "Curățare portbagaj" },
    { icon: <IconDoor />, text: "Curățare fețe uși" },
    { icon: <IconGlass />, text: "Curățare/degresare geamuri și parbriz" },
    { icon: <IconVent />, text: "Curățare/igienizare ventilație" },
    { icon: <IconLeather />, text: "Curățare + hidratare & protecție pentru piele" },
  ].map((it) => ({ ...it, cat: "Interior" }));

  const exterior = [
    { icon: <IconPolishOne />, text: "Polish 1 pas (înlătură „pânza de păianjen”, redă luciul)" },
    { icon: <IconPolishTwo />, text: "Polish 2 pași (70–80% zgârieturi eliminate)" },
    { icon: <IconCorrection />, text: "Corecție lac (matuire + 2 pași polish, 90–95% corecție)" },
    { icon: <IconWheel />, text: "Curățare jante" },
    { icon: <IconEngine />, text: "Curățare motor" },
    { icon: <IconCeramic />, text: "Protecție ceramică profesională (1–5 ani)" },
    { icon: <IconSealant />, text: "Sealant ceramic" },
    { icon: <IconHydro />, text: "Protecție hidrofobă parbriz/lunetă/geamuri" },
  ].map((it) => ({ ...it, cat: "Exterior" }));

  const tiles = [...interior, ...exterior];

  return (
    <section className="py-14 bg-white">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex items-end gap-3 mb-6">
          <div className="h-8 w-1.5 rounded-full bg-manupro-primary" />
          <h2 className="text-2xl sm:text-3xl font-bold text-manupro-ink">Servicii</h2>
        </div>

        {/* Grid pe 1 / 2 / 3 coloane cu carduri „tile” */}
        <div className="grid gap-4 sm:gap-5 md:gap-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
          {tiles.map((item, i) => (
            <ServiceTile key={i} {...item} />
          ))}
        </div>

        {/* Card separat pentru faruri/folie */}
        <div className="rounded-2xl border border-manupro-teal/20 bg-white/80 p-6 mt-8">
          <h3 className="font-semibold text-xl text-manupro-ink mb-3">
            Polish faruri + folii de protecție
          </h3>
          <p className="text-gray-700">
            Recondiționăm farurile matuite/îngălbenite și aplicăm, la cerere, folii de protecție pentru claritate și durabilitate.
          </p>
        </div>
      </div>
    </section>
  );
}

/* Un singur card de serviciu (tile) */
function ServiceTile({ icon, text, cat }) {
  return (
    <div
      className="
        group relative overflow-hidden rounded-2xl border border-manupro-teal/20
        bg-white/80 p-5 sm:p-6 shadow-sm hover:shadow-md transition
      "
    >
      {/* badge categorie (rezervăm spațiu cu pr-20 pe text) */}
      <span className="
        absolute right-3 top-3 rounded-full bg-manupro-primary/10
        text-manupro-primary text-xs font-medium px-2 py-1
        ring-1 ring-manupro-ring/40 pointer-events-none
      ">
        {cat}
      </span>

      <div className="flex items-start gap-4">
        <span className="shrink-0 inline-grid place-items-center h-11 w-11 rounded-xl bg-manupro-primary/10 ring-1 ring-manupro-ring/40 text-manupro-primary">
          <span className="h-6 w-6">{icon}</span>
        </span>

        {/* spațiu pentru badge + text care se rupe corect pe rânduri */}
        <p className="text-manupro-ink/90 pr-20 leading-relaxed break-words">
          {text}
        </p>
      </div>

      {/* accent bar la hover */}
      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-0.5 bg-gradient-to-r from-manupro-primary via-manupro-teal to-manupro-primary opacity-0 group-hover:opacity-100 transition" />
    </div>
  );
}

/* ===================== PREZENTARE (înainte / după) ===================== */
const PRESENTATION_IDS = [1, 2, 3, 4, 5, 6, 7]; // editează după câte perechi ai

function Presentation() {
  return (
    <section className="py-14 bg-white">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex items-end gap-3 mb-6">
          <div className="h-8 w-1.5 rounded-full bg-manupro-primary" />
          <h2 className="text-2xl sm:text-3xl font-bold text-manupro-ink">
            Prezentare (înainte / după)
          </h2>
        </div>

        <div className="grid gap-5 sm:gap-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
          {PRESENTATION_IDS.map((id) => (
            <BeforeAfterCard key={id} id={id} />
          ))}
          <VideoCard />
        </div>
      </div>
    </section>
  );
}

function BeforeAfterCard({ id }) {
  const [after, setAfter] = React.useState(false);
  const [valid, setValid] = React.useState({ before: true, after: true });
  const [open, setOpen] = React.useState(false);

  const beforeSrc = `/before/${id}.jpg`;
  const afterSrc  = `/after/${id}.jpg`;

  // dacă lipsesc imaginile, sărim peste card
  if (!valid.before || !valid.after) return null;

  const currentSrc = after ? afterSrc : beforeSrc;

  return (
    <div className="relative rounded-2xl overflow-hidden border border-manupro-teal/20 bg-white shadow-sm">
      <div
        className="relative aspect-[4/3] bg-gray-100 cursor-zoom-in"
        onClick={() => setOpen(true)}
        title="Mărește"
      >
        {/* BEFORE */}
        <img
          src={beforeSrc}
          alt={`Înainte – ${id}`}
          className={
            "absolute inset-0 h-full w-full object-cover transition-opacity duration-300 " +
            (after ? "opacity-0" : "opacity-100")
          }
          loading="lazy"
          decoding="async"
          onError={() => setValid((v) => ({ ...v, before: false }))}
        />
        {/* AFTER */}
        <img
          src={afterSrc}
          alt={`După – ${id}`}
          className={
            "absolute inset-0 h-full w-full object-cover transition-opacity duration-300 " +
            (after ? "opacity-100" : "opacity-0")
          }
          loading="lazy"
          decoding="async"
          onError={() => setValid((v) => ({ ...v, after: false }))}
        />

        {/* Chip stânga-sus */}
        <span className="absolute left-3 top-3 rounded-full bg-white/80 backdrop-blur text-manupro-ink text-xs font-medium px-2 py-1 ring-1 ring-black/10">
          {after ? "După curățare" : "Înainte"}
        </span>

        {/* Arrows overlay (nu deschid lightbox-ul) */}
        <button
          className="absolute left-2 top-1/2 -translate-y-1/2 grid place-items-center h-9 w-9 rounded-full bg-black/35 text-white hover:bg-black/45 transition"
          onClick={(e) => { e.stopPropagation(); setAfter(false); }}
          aria-label="Înainte"
        >
          ‹
        </button>
        <button
          className="absolute right-2 top-1/2 -translate-y-1/2 grid place-items-center h-9 w-9 rounded-full bg-black/35 text-white hover:bg-black/45 transition"
          onClick={(e) => { e.stopPropagation(); setAfter(true); }}
          aria-label="După"
        >
          ›
        </button>
      </div>

      {/* Bară de acțiuni */}
      <div className="flex items-center justify-between p-3">
        <div className="text-sm text-manupro-ink/70">Set {id}</div>
        <button
          onClick={() => setAfter((v) => !v)}
          className="rounded-full px-3 py-2 text-sm font-medium bg-manupro-primary text-white shadow-brand ring-1 ring-manupro-ring/60 hover:brightness-110 transition"
        >
          {after ? "Vezi înainte" : "După curățare"}
        </button>
      </div>

      {/* Lightbox fullscreen */}
      {open && (
        <ImageLightbox
          src={currentSrc}
          label={after ? "După curățare" : "Înainte"}
          onClose={() => setOpen(false)}
          // opțional: comutare și din lightbox
          onPrev={() => setAfter(false)}
          onNext={() => setAfter(true)}
        />
      )}
    </div>
  );
}

/* ---------- Fullscreen lightbox helper ---------- */
function ImageLightbox({ src, label, onClose, onPrev, onNext }) {
  React.useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
      if (e.key === "ArrowLeft") onPrev?.();
      if (e.key === "ArrowRight") onNext?.();
    };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [onClose, onPrev, onNext]);

  return (
    <div className="fixed inset-0 z-[60]">
      {/* backdrop */}
      <div className="absolute inset-0 bg-black/80" onClick={onClose} />
      {/* controls top */}
      <div className="absolute top-4 left-4 z-10">
        <span className="rounded-full bg-white/90 text-manupro-ink text-xs font-medium px-2 py-1 ring-1 ring-black/10">
          {label}
        </span>
      </div>
      <button
        onClick={onClose}
        aria-label="Închide"
        className="absolute top-4 right-4 z-10 rounded-full bg-white/15 text-white hover:bg-white/25 px-3 py-2"
      >
        ✕
      </button>

      {/* arrows */}
      <button
        onClick={onPrev}
        aria-label="Înainte"
        className="absolute left-2 top-1/2 -translate-y-1/2 z-10 grid place-items-center h-11 w-11 rounded-full bg-white/15 text-white hover:bg-white/25"
      >
        ‹
      </button>
      <button
        onClick={onNext}
        aria-label="După"
        className="absolute right-2 top-1/2 -translate-y-1/2 z-10 grid place-items-center h-11 w-11 rounded-full bg-white/15 text-white hover:bg-white/25"
      >
        ›
      </button>

      {/* image */}
      <div className="absolute inset-0 grid place-items-center p-4">
        <img
          src={src}
          alt={label}
          className="max-h-[92vh] max-w-[92vw] object-contain rounded-xl shadow-2xl"
          loading="eager"
          decoding="async"
        />
      </div>
    </div>
  );
}

function VideoCard() {
  return (
    <div className="relative rounded-2xl overflow-hidden border border-manupro-teal/20 bg-white shadow-sm">
      <div className="relative aspect-[4/3] bg-black">
        <video
          src="/videos/1.mp4"
          controls
          preload="metadata"
          className="absolute inset-0 h-full w-full object-cover"
        />
      </div>
      <div className="p-3 flex items-center justify-between">
        <span className="text-sm text-manupro-ink/80">Video demonstrație</span>
        <span className="text-xs px-2 py-1 rounded-full bg-manupro-primary/10 text-manupro-primary ring-1 ring-manupro-ring/40">
          HD
        </span>
      </div>
    </div>
  );
}

/* ===================== CONTACT ===================== */
function ContactSection() {
  return (
    <section className="py-14 bg-white border-t border-manupro-teal/20">
      <div className="max-w-6xl mx-auto px-4">
        {/* Title */}
        <div className="flex items-end gap-3 mb-6">
          <div className="h-8 w-1.5 rounded-full bg-manupro-primary" />
          <h2 className="text-2xl sm:text-3xl font-bold text-manupro-ink">
            Contact & Locație
          </h2>
        </div>

        {/* Grid: info + map */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Card info */}
          <div className="rounded-2xl border border-manupro-teal/20 bg-white/90 p-6 shadow-sm">
            <h3 className="text-xl font-semibold text-manupro-ink mb-2">
              Manu <span className="text-manupro-primary">Pro</span> Detailing
            </h3>
            <p className="text-gray-700 mb-4">
              Remetea Mare - Programări telefonice.
            </p>

            <div className="space-y-3 text-sm">
              <div className="flex items-center gap-3">
                <span className="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-manupro-primary/10 ring-1 ring-manupro-ring/40 text-manupro-primary">
                  {/* phone icon */}
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M22 16.92V21a2 2 0 0 1-2.18 2 19.86 19.86 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.86 19.86 0 0 1 2 4.18 2 2 0 0 1 4 2h4.09a2 2 0 0 1 2 1.72c.12.86.31 1.7.57 2.5a2 2 0 0 1-.45 2.11L9.1 9.9a16 16 0 0 0 6 6l1.57-1.11a2 2 0 0 1 2.11-.45c.8.26 1.64.45 2.5.57A2 2 0 0 1 22 16.92z"/>
                  </svg>
                </span>
                <div>
                  <div className="text-manupro-ink/60">Telefon</div>
                  <a href="tel:+40762705175" className="text-manupro-ink font-medium hover:underline">
                    +40 762 705 175
                  </a>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <span className="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-manupro-primary/10 ring-1 ring-manupro-ring/40 text-manupro-primary">
                  {/* pin icon */}
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 10c0 6-9 13-9 13S3 16 3 10a9 9 0 1 1 18 0z"/><circle cx="12" cy="10" r="3"/>
                  </svg>
                </span>
                <div>
                  <div className="text-manupro-ink/60">Zonă acoperită</div>
                  <div className="text-manupro-ink font-medium">Jundețul Timiș</div>
                </div>
              </div>
            </div>

            <div className="mt-5 flex flex-wrap gap-3">
              <a
                href="tel:+40762705175"
                className="rounded-full px-5 py-2.5 font-medium text-white bg-manupro-primary shadow-brand ring-1 ring-manupro-ring/60 hover:brightness-110 transition"
              >
                Sună acum
              </a>
              <a
                href="#gallery"
                className="rounded-full px-5 py-2.5 font-medium bg-white text-manupro-ink border border-manupro-teal/20 hover:bg-white/80 transition"
              >
                Vezi galeria
              </a>
            </div>
          </div>

          {/* Map */}
          <div className="rounded-2xl overflow-hidden border border-manupro-teal/20 shadow-sm">
            <div className="relative aspect-[4/3] sm:aspect-[16/9] bg-gray-100">
              <iframe
                title="Harta Manu Pro Detailing"
                src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d15738.38830626952!2d21.375708036721743!3d45.787615993461635!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNDXCsDQ3JzAwLjMiTiAyMcKwMjInNTcuMyJF!5e0!3m2!1sro!2sro!4v1759844841901!5m2!1sro!2sro"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
                className="absolute inset-0 h-full w-full border-0"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}


export default function Home({ onOpenGallery }) {
  return (
    <main className="bg-white">
      <Hero onOpenGallery={onOpenGallery} />
      <Services />
       <Presentation /> 
      <ContactSection />
    </main>
  );
}

/* ===== ICOANE (SVG inline, currentColor) ===== */
function baseSvg(props) {
  return {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ...props,
  };
}

function IconSteam() {
  return (
    <svg {...baseSvg({})}>
      <path d="M6 16c0-2 2-2 2-4s-2-2-2-4" />
      <path d="M12 16c0-2 2-2 2-4s-2-2-2-4" />
      <path d="M18 16c0-2 2-2 2-4s-2-2-2-4" />
      <rect x="3" y="16" width="18" height="4" rx="1" />
    </svg>
  );
}
function IconCarpet() {
  return (
    <svg {...baseSvg({})}>
      <rect x="4" y="6" width="16" height="12" rx="2" />
      <path d="M4 8h16M4 16h16" />
      <path d="M6 4v2M18 4v2M6 18v2M18 18v2" />
    </svg>
  );
}
function IconDashboard() {
  return (
    <svg {...baseSvg({})}>
      <rect x="3" y="4" width="18" height="6" rx="1" />
      <rect x="3" y="12" width="8" height="8" rx="1" />
      <rect x="13" y="12" width="8" height="8" rx="1" />
    </svg>
  );
}
function IconShield() {
  return (
    <svg {...baseSvg({})}>
      <path d="M12 3l7 3v5c0 5-3.5 8-7 10-3.5-2-7-5-7-10V6l7-3z" />
    </svg>
  );
}
function IconTrunk() {
  return (
    <svg {...baseSvg({})}>
      <rect x="3" y="9" width="18" height="10" rx="2" />
      <path d="M5 9V7a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v2" />
    </svg>
  );
}
function IconDoor() {
  return (
    <svg {...baseSvg({})}>
      <rect x="7" y="3" width="10" height="18" rx="1" />
      <circle cx="9.5" cy="12" r="0.8" />
    </svg>
  );
}
function IconGlass() {
  return (
    <svg {...baseSvg({})}>
      <rect x="3" y="5" width="18" height="8" rx="2" />
      <path d="M8 13v6m8-6v6" />
      <path d="M3 9h18" />
    </svg>
  );
}
function IconVent() {
  return (
    <svg {...baseSvg({})}>
      <circle cx="12" cy="12" r="3" />
      <path d="M12 3v3M21 12h-3M12 21v-3M3 12h3" />
    </svg>
  );
}
function IconLeather() {
  return (
    <svg {...baseSvg({})}>
      <path d="M12 2c3 2 7 2 7 6v8c0 4-4 4-7 6-3-2-7-2-7-6V8c0-4 4-4 7-6z" />
      <path d="M12 6v12" />
    </svg>
  );
}
function IconPolishOne() {
  return (
    <svg {...baseSvg({})}>
      <circle cx="8" cy="12" r="3" />
      <path d="M11 12h9" />
      <path d="M20 10v4" />
    </svg>
  );
}
function IconPolishTwo() {
  return (
    <svg {...baseSvg({})}>
      <circle cx="7.5" cy="12" r="3" />
      <circle cx="14.5" cy="12" r="3" />
      <path d="M3 12h2m14 0h2" />
    </svg>
  );
}
function IconCorrection() {
  return (
    <svg {...baseSvg({})}>
      <rect x="4" y="4" width="16" height="16" rx="2" />
      <path d="M7 12h10" />
      <path d="M9.5 8h5M9.5 16h5" />
    </svg>
  );
}
function IconWheel() {
  return (
    <svg {...baseSvg({})}>
      <circle cx="12" cy="12" r="7" />
      <circle cx="12" cy="12" r="2" />
      <path d="M12 5v5m7 2h-5m-2 7v-5M5 12h5" />
    </svg>
  );
}
function IconEngine() {
  return (
    <svg {...baseSvg({})}>
      <rect x="3" y="8" width="18" height="8" rx="2" />
      <path d="M7 8V6h5l2 2h3" />
      <path d="M6 12h12" />
    </svg>
  );
}
function IconCeramic() {
  return (
    <svg {...baseSvg({})}>
      <path d="M12 3l9 5-9 5-9-5 9-5z" />
      <path d="M12 13v8" />
    </svg>
  );
}
function IconSealant() {
  return (
    <svg {...baseSvg({})}>
      <rect x="5" y="4" width="6" height="16" rx="2" />
      <path d="M11 8h6l2 2-2 2h-6" />
    </svg>
  );
}
function IconHydro() {
  return (
    <svg {...baseSvg({})}>
      <path d="M12 3s5 5 5 9a5 5 0 0 1-10 0c0-4 5-9 5-9z" />
    </svg>
  );
}
